import type { CSSProperties } from 'react'

export { breakLines } from './break-lines'
export { canvasMeasure, type Measure } from './measure'
export {
  breakAndReflowCommand,
  joinLines,
  lineBreaksPlugin,
  parsePastedText,
  reflowCommand,
} from './plugin'
export { lineStart, reflow } from './reflow'

// Text width of each field in em; the dashed guide is drawn from the same value
// - Burial place and ping keep their guide at 26em / 24em: minus the 10px padding (2/3em at 15px).
export const LINE_WIDTH = {
  quote: 35,
  insight: 25,
  note: 20,
  ping: 24 - 2 / 3,
  pingSource: 21,
  burialPlace: 26 - 2 / 3,
} as const

// The guide's position (`--md-line-width`); the only source the CSS reads it from
export const lineWidthStyle = (lineWidth?: number) =>
  lineWidth ? ({ '--md-line-width': `${lineWidth}em` } as CSSProperties) : undefined
